var _path, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 34,
    viewBox: "0 0 29 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5 14.0909C27.5 24.2727 14.5 33 14.5 33C14.5 33 1.5 24.2727 1.5 14.0909C1.5 6.861 7.3203 1 14.5 1C21.6797 1 27.5 6.861 27.5 14.0909Z",
    fill: "#AB6626",
    stroke: "#AB6626",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5,
    width: 18,
    height: 18,
    rx: 9,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1160_3948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1667 15.6667V10.25H9.91675V15.6667H16.1667ZM16.1667 15.6667H19.0834V13.5833L17.8334 12.3333H16.1667V15.6667ZM12.8334 16.7083C12.8334 17.2836 12.367 17.75 11.7917 17.75C11.2165 17.75 10.7501 17.2836 10.7501 16.7083C10.7501 16.133 11.2165 15.6667 11.7917 15.6667C12.367 15.6667 12.8334 16.133 12.8334 16.7083ZM18.2501 16.7083C18.2501 17.2836 17.7837 17.75 17.2084 17.75C16.6331 17.75 16.1667 17.2836 16.1667 16.7083C16.1667 16.133 16.6331 15.6667 17.2084 15.6667C17.7837 15.6667 18.2501 16.133 18.2501 16.7083Z",
    stroke: "#AB6626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1160_3948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(9.5 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerDriver);
export default __webpack_public_path__ + "static/media/marker-driver.654580d93ed8b0d1d16b4903c6a439db.svg";
export { ForwardRef as ReactComponent };